import { render } from "./GroupFullfieldView.vue?vue&type=template&id=2000d750"
import script from "./GroupFullfieldView.vue?vue&type=script&lang=js"
export * from "./GroupFullfieldView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__